import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';

import CircleIcon from './icons/circle_icon';

export default class EndCallButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <g id="iconEndCall">
          <path d="M7.496 8.1c3.726-1.583 7.26-1.558 10.575.115.957.483 1.16 1.237.684 2.065-.247.427-.58.686-1.104.596-.505-.087-1.017-.155-1.515-.264-1.297-.285-1.28-.294-1.36-1.595-.012-.19-.224-.482-.392-.497-1.02-.087-2.053-.132-3.088-.14-.435-.003-.662.28-.666.707-.006.82-.482 1.228-1.345 1.32-.552.06-1.102.185-1.655.26-.517.07-1.007.09-1.187-.488-.194-.623-.127-1.196.434-1.752.19-.102.397-.234.62-.328M10.176 17.013H7.502v-1.18h2.24v-.82h-2.24v-.986h2.625v-.82h-3.55v4.626h3.6v-.82zm4.2-1.186c0-.907-.56-1.514-1.407-1.514-.386 0-.7.16-.932.42V14.4h-.882v3.433h.924v-2.006c0-.387.287-.68.7-.68.61 0 .672.48.672.68v2.006h.924v-2.006zm4.662-2.954h-.924v1.854c-.28-.254-.644-.4-1.064-.4-.938 0-1.715.773-1.715 1.793 0 1.013.777 1.787 1.715 1.787.44 0 .82-.16 1.106-.44v.366h.882v-4.96zm-.924 3.254c0 .533-.413.966-.924.966-.51 0-.924-.42-.924-.966 0-.56.413-.987.924-.987.51 0 .924.44.924.987z" />
        </g>
      </CircleIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/buttons/endcall_button.jsx